// extracted by mini-css-extract-plugin
module.exports = {"fixed_header":"style_fixed_header__1J9Fu","view":"style_view__13PJI","fold":"style_fold__3fYhM","open":"style_open__13LcZ","textAlign_center":"style_textAlign_center__25KA6"};